import React from 'react';
import {
    Dialog as MuiDialog,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
    Button,
    DialogTitle,
    Divider,
} from '@mui/material';
import { Close } from '@mui/icons-material';

export const Dialog = (props) => {
    const {
        open,
        title,
        onClose,
        onConfirm,
        message,
        dialogSize = 'xs',
        type = 'warning', // "danger", "info", "warning"
        confirmText = 'Confirm',
        cancelText = 'Cancel',
        loading = false,
        dialogActions = true,
        dialogTitle = true,
    } = props;

    return (
        <MuiDialog className="dialog" open={open} onClose={!loading ? onClose : undefined} maxWidth={dialogSize} fullWidth>
            <IconButton size="small" className="close-button" onClick={!loading ? onClose : undefined}>
                <Close />
            </IconButton>

            {dialogTitle ? (
                <>
                    <DialogTitle className="title-container">{title}</DialogTitle>
                    <Divider />
                </>
            ) : null}

            <DialogContent className="content-container">
                <Typography variant="body1" className="message">
                    {message}
                </Typography>
            </DialogContent>

            {dialogActions ? (
                <DialogActions className="action-container">
                    <Button variant="outlined" color="secondary" onClick={onClose} disabled={loading}>
                        {cancelText}
                    </Button>
                    <Button
                        variant="contained"
                        color={type === 'danger' ? 'error' : 'primary'}
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Processing...' : confirmText}
                    </Button>
                </DialogActions>
            ) : null}
        </MuiDialog>
    );
};
